import { useSmsVerification } from '@/hooks/useSmsVerification';
import type { PatchPatientForInstantConsultationReply } from '@/pages/NurseConsultation';
import { Button } from '@montugroup/design-system';

type ResendSmsButtonProps = {
  onSubmit: () => Promise<PatchPatientForInstantConsultationReply>;
  sendSmsRetryCount: number;
};

export const ResendSmsButton = ({ onSubmit, sendSmsRetryCount }: ResendSmsButtonProps) => {
  const { startSmsVerificationCountdown, retryPermitted, label } = useSmsVerification({
    sendSmsRetryCount,
  });

  const onHandleResendSms = async () => {
    const response = await onSubmit();
    startSmsVerificationCountdown(response?.data?.retryAfterMs || 0);
  };

  return (
    <Button
      type="button"
      color="primary"
      size="large"
      variant="contained"
      onClick={onHandleResendSms}
      disabled={!retryPermitted}
    >
      {label}
    </Button>
  );
};
